import { useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import * as actions from '../store/actions'
import { AppContext } from '../..'
import { useTranslation } from 'react-i18next'

function ErrorHandler() {
  const history = useHistory()
  const { state, execute } = useContext(AppContext)
  const { lastError, alert } = state.diags
  const lastErrorId = lastError ? lastError.id : null
  const { t } = useTranslation(['errors'])

  function showAlert(title: string, text: string) {
    execute(actions.showAlert(title, text))
  }

  useEffect(() => {
    if (lastError) {
      if (lastError.fromApi) {
        if (lastError.httpStatus === 401) {
          history.push('/login')
        } else if (lastError.httpStatus === 408 || lastError.httpStatus === 504) {
          if (!alert.open) {
            showAlert(t('sorry') , t('no_internet'))
          }
        } else {
          showAlert(t('sorry'), t('application_error'))
        }
      } else {
        showAlert(t('sorry'), t('application_error'))
      }
    }
  },
    // eslint-disable-next-line
    [lastErrorId])

  return null
}

export default ErrorHandler
